import { Facebook, Instagram, WhatsApp, AdminPanelSettings } from '@mui/icons-material';
import { Box, Typography, Divider, Grid } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';
import { FaCode, FaHeart, FaUsers, FaCrown } from 'react-icons/fa';

const Footer = () => {
  const executiveTeam = [
    { name: "Gift K Mphakati", position: "President" },
    { name: "Oneva Soka", position: "Vice President & Lead Developer" },
    { name: "Jr Eli Silomba", position: "Secretary General" },
    { name: "Venus Ramazani", position: "Academic Secretary" },
    { name: "Kalevi Nachinsambwe", position: "Treasurer General" },
    { name: "Promise Ndhlovu", position: "Research and Consultancy" },
    { name: "Vladmir W", position: "Project Coordinator" },
    { name: "Anna Mulenga", position: "Information Publicity Secretary" },
    { name: "Lucia James", position: "Committee Member" },
    { name: "Majid Jawad", position: "Committee Member" },
    { name: "Dignity Kabungo", position: "Committee Member" },
  ];

  const pastLeadership = [
    { name: "Muhammad Bwengo", position: "President 2023-2024" },
    { name: "Samson C Chishala", position: "Vice President 2023-2024" },
    { name: "Razeal Shumba", position: "President 2022-2023" },
  ];

  return (
    <Box sx={{ bgcolor: '#0a192f', pt: 5, pb: 4, textAlign: 'center', boxShadow: '0px -4px 10px rgba(0, 217, 255, 0.3)' }}>
      {/* Past Leadership Section */}
      <Box sx={{ maxWidth: 900, mx: 'auto', mb: 4, px: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
          <FaUsers size={24} color="#00d9ff" />
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 700 }}>
            Past Leadership
          </Typography>
        </Box>

        <Box
          sx={{
            background: 'rgba(0, 217, 255, 0.1)',
            borderRadius: '15px',
            border: '1px solid rgba(0, 217, 255, 0.2)',
            p: 3,
            mb: 3,
          }}
        >
          <Typography 
            variant="body1" 
            sx={{ 
              color: 'rgba(255, 255, 255, 0.9)', 
              mb: 3,
              fontSize: '0.95rem'
            }}
          >
            We acknowledge and thank our past leaders for their dedication in keeping the association running:
          </Typography>

          <Grid container spacing={2} justifyContent="center">
            {pastLeadership.map((member, index) => (
              <Grid item xs={12} sm={4} key={index}>
                <Box sx={{ textAlign: 'center', py: 1 }}>
                  <Typography variant="body1" sx={{ color: 'white', fontWeight: 600 }}>
                    {member.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: '#00d9ff', fontSize: '0.8rem', display: 'block' }}>
                    {member.position}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Divider sx={{ my: 2, borderColor: 'rgba(0, 217, 255, 0.2)' }} />

          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', fontStyle: 'italic' }}>
            Your leadership continues to inspire our journey forward
          </Typography>
        </Box>
      </Box>

      {/* Developer Credits Section */}
      <Box sx={{ maxWidth: 900, mx: 'auto', mb: 4, px: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 3 }}>
          <FaCode size={24} color="#00d9ff" />
          <Typography variant="h6" sx={{ color: 'white', fontWeight: 700 }}>
            Development & Executive Team 2024-2025
          </Typography>
        </Box>

        <Box
          sx={{
            background: 'rgba(0, 217, 255, 0.1)',
            borderRadius: '15px',
            border: '1px solid rgba(0, 217, 255, 0.2)',
            p: 3,
            mb: 3,
          }}
        >
          {/* Lead Developer Highlight */}
          <Box sx={{ textAlign: 'center', mb: 3 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 1 }}>
              <FaCrown size={18} color="#ffd700" />
              <Typography variant="body2" sx={{ color: '#ffd700', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>
                Lead Developer
              </Typography>
            </Box>
            <Typography variant="h6" sx={{ color: '#00d9ff', fontWeight: 700 }}>
              Oneva Soka
            </Typography>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
              Vice President 2024-2025
            </Typography>
          </Box>

          <Divider sx={{ my: 2, borderColor: 'rgba(0, 217, 255, 0.2)' }} />

          {/* Executive Team Grid */}
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1, mb: 2 }}>
            <FaUsers size={18} color="#00d9ff" />
            <Typography variant="body2" sx={{ color: '#00d9ff', fontWeight: 600, textTransform: 'uppercase', letterSpacing: 1 }}>
              Executive Team
            </Typography>
          </Box>

          <Grid container spacing={1} justifyContent="center">
            {executiveTeam.map((member, index) => (
              <Grid item xs={6} sm={4} md={3} key={index}>
                <Box sx={{ textAlign: 'center', py: 1 }}>
                  <Typography variant="body2" sx={{ color: 'white', fontWeight: 600, fontSize: '0.85rem' }}>
                    {member.name}
                  </Typography>
                  <Typography variant="caption" sx={{ color: 'rgba(255, 255, 255, 0.6)', fontSize: '0.7rem' }}>
                    {member.position}
                  </Typography>
                </Box>
              </Grid>
            ))}
          </Grid>

          <Divider sx={{ my: 2, borderColor: 'rgba(0, 217, 255, 0.2)' }} />

          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', fontStyle: 'italic' }}>
            Special thanks to the entire ICTAZ NIPA Chapter community for their support
          </Typography>
        </Box>
      </Box>

      {/* Social Icons */}
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 2,
        mb: 3,
        "& svg": {
          fontSize: "40px",
          cursor: 'pointer',
          transition: 'transform 0.3s ease-in-out, color 0.3s ease-in-out',
          color: 'white',
          '&:hover': {
            transform: 'scale(1.2)',
          }
        }
      }}>
        <Facebook sx={{ '&:hover': { color: '#1877F2' } }} />
        <Instagram sx={{ '&:hover': { color: '#E1306C' } }} />
        <WhatsApp sx={{ '&:hover': { color: '#25D366' } }} />
      </Box>

      {/* Footer Text */}
      <Typography variant="h6" sx={{ color: 'white', fontWeight: 500 }}>
        All rights reserved &copy; {new Date().getFullYear()} ICTAZ NIPA Chapter
      </Typography>

      {/* Additional Info */}
      <Typography variant="body2" sx={{ color: 'gray', mt: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
        Designed & Developed with <FaHeart size={14} color="#00d9ff" /> by Oneva Soka
      </Typography>
      <Typography variant="body2" sx={{ color: '#00d9ff', mt: 1 }}>
        Powered by React
      </Typography>

      {/* Admin Login Link */}
      <Link to="/login" style={{ textDecoration: 'none' }}>
        <Box
          sx={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            mt: 2,
            px: 2,
            py: 0.5,
            borderRadius: '20px',
            background: 'rgba(0, 217, 255, 0.1)',
            border: '1px solid rgba(0, 217, 255, 0.2)',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            '&:hover': {
              background: 'rgba(0, 217, 255, 0.2)',
              border: '1px solid rgba(0, 217, 255, 0.4)',
            },
          }}
        >
          <AdminPanelSettings sx={{ fontSize: 16, color: 'rgba(255,255,255,0.6)' }} />
          <Typography variant="caption" sx={{ color: 'rgba(255,255,255,0.6)' }}>
            Admin Panel
          </Typography>
        </Box>
      </Link>
    </Box>
  );
};

export default Footer;